import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2254">
      <About data-id="element-2255" />
    </main>;
}